import React from 'react';
import { Badge, Drawer, Button, Card } from 'antd';
import './style.less';
import { FiShoppingCart } from 'react-icons/fi';
import { RiDeleteBin7Line } from 'react-icons/ri';
import { useStore } from "../../store";
import { useHistory } from "react-router-dom";

function Cart() {
	const history = useHistory();
	const [ drawer, setDrawer ] = React.useState(false)
	const { state, dispatch } = useStore()
	const checkoutPage = () => {
		history.push('/checkout')
		setDrawer(false)
	}
	
    return (
    	<div>
	    	<Drawer
	          title="Cart"
	          placement="right"
	          width={280}
	          closable={true}
	          onClose={() => setDrawer(false)}
	          visible={drawer}
	        >

	          {
	          	state.cart.map((domain)=>(
		          	<Card size="small" title={domain.title} extra={<a href="##" onClick={()=> dispatch({type: "REMOVE_FROM_CART", payload: domain})} ><RiDeleteBin7Line/></a>} style={{ margin:'10px 10px' }}>
		  			      <p>{domain.des}</p>
		  			      <h3>{domain.dPrice}৳</h3>
		  			</Card>
		        ))
	          }
	          <Button onClick={checkoutPage} style={{borderRadius: 0}} size='large' className="checkoutbtn" type="primary">Checkout</Button>
	        </Drawer>

		    {state.cart.length?
	    	  <Badge count={state.cart.length} style={{ backgroundColor: '#faad14' }} className="cartIconBody">
		      	<div onClick={() => setDrawer(true)} className="cartIcon">
		        	<FiShoppingCart color="white" size="18px"/>
		        </div>
		      </Badge>:''
		    }
		      
		    
		</div>
    );
}

export default Cart;
